<template>
  <div class="card" v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職歴を入力</h2>
        <p>「自動入力」を使うと、入社・退社表記を自動で作成できます。</p>
      </div>

      <div class="card-content-list">
        <div class="edit-form-item">
          <div class="item-name">希望業界</div>
          <div class="item-body">
            <el-select
              v-model="formatData.hopeIndustry"
              placeholder="選択してください"
            >
              <el-option
                v-for="item in hopeIndustryOptions"
                :key="item"
                :label="item"
                :style="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="item-name">希望職種</div>
          <div class="item-body">
            <el-select
              v-model="formatData.hopeJobcategory"
              placeholder="選択してください"
            >
              <el-option
                v-for="item in hopeJobcategoryOptions"
                :key="item"
                :label="item"
                :style="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
        <div class="edit-form-list">
          <div class="add-item">
            <AutoJobHistories
              @job-histories-created="$emit('set-job-histories', $event)"
              :birth-year="basicData.birthYear"
              :birth-month="basicData.birthMonth"
              :birth-day="basicData.birthDay"
            />
            <div class="button-reset">
              <el-button
                type=""
                v-if="
                  formatData.jobHistories && formatData.jobHistories.length > 1
                "
                @click="$emit('update:job-reset-visible', true)"
                >リセット</el-button
              >
            </div>
            <CareerYagiofferResetDialog
              :value="jobResetVisible"
              name="job-reset"
              title="職歴リセット"
              message="現在入力されている職歴をすべて削除します。よろしいですか？"
              @input="$emit('update:job-reset-visible', $event)"
              @confirm="$emit('reset-job-histories')"
            />
          </div>
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.jobHistories"
              :key="item.uuid"
              @add-history-item="onAddJobHistory"
              @delete-history-item="$emit('delete-job-history', $event)"
              @move-history-item="$emit('move-job-history', $event)"
              @click.native="$emit('activate-history-item', item.uuid)"
              :item="item"
              :length="formatData.jobHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'職歴を入力'"
              :descriptionMaxLength="descriptionMaxLength"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="$emit('add-job-history')"
            />
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.eduJobHistory"
          >
            <i class="el-icon-warning"></i>&ensp;{{
              previewErrors.eduJobHistory
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import AutoJobHistories from '@/components/formats/RirekishoParts/AutoJobHistories.vue'
import CareerYagiofferResetDialog from './CareerYagiofferResetDialog.vue'
import hopeIndustryOptions from '@/utils/format-edit/hopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/hopeJobcategoryOptions.json'
import { useCareerYagiofferFormatData } from '@/composables/format-edit/useCareerYagiofferHistories'

defineProps<{
  basicData: Record<string, unknown>
  currentCardId?: string
  previewErrors: Record<string, string>
  activeHistoryItem: string
  jobResetVisible: boolean
  descriptionMaxLength: number
}>()

const emit = defineEmits([
  'set-job-histories',
  'update:job-reset-visible',
  'reset-job-histories',
  'add-job-history',
  'delete-job-history',
  'move-job-history',
  'activate-history-item'
])

const formatData = useCareerYagiofferFormatData()

function onAddJobHistory(
  index?: number,
  columns?: { year?: number; month?: number; description?: string }
) {
  emit('add-job-history', index, columns)
}
</script>
